var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8896 17.0402L34.5714 15.4242V15.0703H28.7469L24.5959 25.4519L19.8743 15.0703H13.7671V15.4242L15.7315 17.8001C15.9236 17.9757 16.0223 18.2336 15.9976 18.4915V27.8278C16.058 28.1652 15.951 28.5082 15.7151 28.7524L13.501 31.4493V31.7977H19.7728V31.4438L17.5615 28.7551C17.443 28.6348 17.3539 28.4888 17.301 28.3284C17.2482 28.1681 17.2331 27.9977 17.2569 27.8305V19.7535L22.7632 31.8032H23.4025L28.1378 19.7535V29.3532C28.1378 29.6056 28.1378 29.6577 27.9732 29.8251L26.2695 31.4794V31.8334H34.533V31.4794L32.8896 29.8635C32.747 29.7538 32.6729 29.5699 32.7031 29.3916V17.5121C32.6889 17.4239 32.6987 17.3335 32.7315 17.2505C32.7644 17.1674 32.819 17.0948 32.8896 17.0402Z",
    fill: "#171717"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/Medium.c239b6c225a769818eb4622c00cae044.svg";
export { ForwardRef as ReactComponent };